function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";

/*
 * "New image" start screens (create flow redesign 2026-10-08): the shell, the three ways, and the small pieces the
 * Describe it / Start from a product / Upload a photo screens share. The logic stays in image-workspace.jsx; these are
 * presentational. Styles: sass/v2/_image-new.scss, every class `in-` prefixed under `.in-view`.
 */

export const WAYS = [["create", "Describe it"], ["pick", "Start from a product"], ["upload", "Upload a photo"]];

/** Top bar: back, "New image", the current way as plain text and links to the other two, then the actions. */
export function NewTop({
  mode,
  onBack,
  onMode,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "iwx-top in-top"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "iwx-iconbtn",
    "aria-label": "Back to Content Hub",
    title: "Back to Content Hub",
    onClick: onBack
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    "aria-hidden": "true"
  }, "chevron_left")), /*#__PURE__*/React.createElement("div", {
    className: "iwx-title in-title"
  }, /*#__PURE__*/React.createElement("b", null, "New image"), /*#__PURE__*/React.createElement("span", {
    className: "in-ways"
  }, WAYS.map(([k, l], i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: k
  }, i > 0 ? /*#__PURE__*/React.createElement("i", {
    "aria-hidden": "true"
  }, "\xB7") : null, k === mode ? /*#__PURE__*/React.createElement("em", {
    "aria-current": "page"
  }, l) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "in-link",
    onClick: () => onMode(k)
  }, l))))), /*#__PURE__*/React.createElement("span", {
    className: "sp"
  }), children);
}

/** Segmented control (single choice). */
export function Segs({
  list,
  value,
  onChange,
  disabled,
  off,
  label,
  offTitle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "in-seg",
    role: "group",
    "aria-label": label
  }, list.map(([k, l]) => {
    const isOff = off && off(k);
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: String(k),
      "aria-pressed": value === k,
      className: value === k ? "on" : "",
      disabled: disabled || isOff,
      title: isOff ? offTitle : undefined,
      onClick: () => onChange(k)
    }, l);
  }));
}

/** Wrapping chips (single or multi choice). */
export function Chips({
  list,
  value,
  onChange,
  disabled,
  off,
  label,
  offTitle,
  multi
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "in-chips",
    role: "group",
    "aria-label": label
  }, list.map(([k, l]) => {
    const on = multi ? (value || []).indexOf(k) !== -1 : value === k;
    const isOff = off && off(k);
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: String(k),
      "aria-pressed": on,
      className: (on ? "on" : "") + (isOff ? " off" : ""),
      disabled: disabled || isOff,
      title: isOff ? offTitle : undefined,
      onClick: () => onChange(k)
    }, l);
  }));
}

/** Right-rail section with a plain heading. */
export function Sect({
  title,
  note,
  children,
  id
}) {
  return /*#__PURE__*/React.createElement("section", {
    className: "in-sect",
    "aria-labelledby": id
  }, /*#__PURE__*/React.createElement("h3", {
    id: id
  }, title, note ? /*#__PURE__*/React.createElement("small", null, note) : null), children);
}

/** Soft placeholder tiles before anything is made (or while making): each shows the chosen shape. */
export function PlaceholderTiles({
  n,
  ratio,
  busy,
  label
}) {
  const tiles = [];
  for (let i = 0; i < n; i++) {
    tiles.push(/*#__PURE__*/React.createElement("div", {
      key: i,
      className: "in-tile ph" + (busy ? " busy" : ""),
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("span", {
      className: "frame",
      style: {
        aspectRatio: ratio
      }
    }), busy && i === 0 && label ? /*#__PURE__*/React.createElement("span", {
      className: "lbl"
    }, label) : null));
  }
  return tiles;
}

/** Library picker for the "keep exact" photos: up to `max`, faces never sent. */
export class RefPicker extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      q: ""
    });
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape") this.props.onClose();
    });
    _defineProperty(this, "search", q => {
      this.setState({
        q
      });
      clearTimeout(this._t);
      this._t = setTimeout(() => this.props.onSearch(q.trim()), 250);
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKey);
    if (this._done) this._done.focus();
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKey);
    clearTimeout(this._t);
  }
  render() {
    const {
      list,
      refs,
      max,
      onToggle,
      onClose
    } = this.props;
    const full = refs.length >= max;
    return /*#__PURE__*/React.createElement("div", {
      className: "in-modal",
      role: "presentation",
      onMouseDown: e => {
        if (e.target === e.currentTarget) onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "in-dialog",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "in-refpick-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "in-dialog-head"
    }, /*#__PURE__*/React.createElement("h2", {
      id: "in-refpick-h"
    }, "Add photos to keep"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "iwx-iconbtn",
      "aria-label": "Close",
      onClick: onClose
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "close"))), /*#__PURE__*/React.createElement("p", {
      className: "in-dialog-lead"
    }, "Pick up to ", max, ". What is in these photos stays true in every preview. Photos with a face are never sent to the image model; they stay in your library."), /*#__PURE__*/React.createElement("label", {
      className: "in-search sm"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "search"), /*#__PURE__*/React.createElement("span", {
      className: "in-sr"
    }, "Search your library"), /*#__PURE__*/React.createElement("input", {
      value: this.state.q,
      placeholder: "Search your library by title",
      onChange: e => this.search(e.target.value)
    })), /*#__PURE__*/React.createElement("div", {
      className: "in-dialog-body"
    }, list === null ? /*#__PURE__*/React.createElement("p", {
      className: "in-muted"
    }, "Loading your library\u2026") : !list.length ? /*#__PURE__*/React.createElement("p", {
      className: "in-muted"
    }, "No images match. Upload a photo first, then add it here.") : /*#__PURE__*/React.createElement("div", {
      className: "in-libgrid sm"
    }, list.map((a, i) => {
      const on = !!a.id && refs.indexOf(a.id) !== -1;
      const blocked = a.hasFaces || !a.id;
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        key: a.id || a.url + i,
        className: "in-libtile" + (on ? " on" : ""),
        "aria-pressed": on,
        disabled: blocked || !on && full,
        title: a.hasFaces ? "Face found: never sent to the image model" : a.title || "Untitled",
        onClick: () => onToggle(a)
      }, /*#__PURE__*/React.createElement("span", {
        className: "im"
      }, /*#__PURE__*/React.createElement("img", {
        src: a.url,
        alt: "",
        loading: "lazy"
      })), on ? /*#__PURE__*/React.createElement("span", {
        className: "tick",
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "check")) : null, a.hasFaces ? /*#__PURE__*/React.createElement("span", {
        className: "tag warn"
      }, "Face found") : null, /*#__PURE__*/React.createElement("span", {
        className: "cap"
      }, a.title || "Untitled"));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "in-dialog-foot"
    }, /*#__PURE__*/React.createElement("span", {
      className: "in-muted"
    }, refs.length, " of ", max, " picked"), /*#__PURE__*/React.createElement("span", {
      className: "sp"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "in-primary",
      ref: r => {
        this._done = r;
      },
      onClick: onClose
    }, "Done"))));
  }
}